function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dae5ec",
  d: "M9 11.75v56.5h42.38V21.9l-9.49-10.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d1dde3",
  d: "M9 12c2.65.88 6 2.42 7.51 5.74 2.86 5.73-2.65 10.81 0 17 2.42 5.74 8.6 4 11.69 9.94 3.09 6.18-2.2 11.25.22 16.55C30 64.72 35.05 68 49.84 68.25H9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b0c5d1",
  d: "M37.47 23H25.11a.7.7 0 01-.66-.66.58.58 0 01.66-.66h12.36a.7.7 0 01.67.66c.22.22-.22.66-.67.66M47 30.07H25.11a.7.7 0 01-.66-.67 1 1 0 01.66-.66H47a.67.67 0 010 1.33m-.25 7.28h-32a.66.66 0 110-1.32h32a.7.7 0 01.66.66 1 1 0 01-.66.66M47 51.7H14.74a.7.7 0 01-.66-.66.71.71 0 01.66-.67H47a.71.71 0 01.66.67.7.7 0 01-.66.66m.19 7.06H14.74a.66.66 0 010-1.32h32.45a.66.66 0 010 1.32M47 44.41H14.74a.7.7 0 01-.66-.66 1 1 0 01.66-.66H47a.66.66 0 010 1.32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9271",
  d: "M71.91 54.79h-28.7a2.93 2.93 0 01-2.87-2.87V35.59a2.92 2.92 0 012.87-2.87h28.92A2.92 2.92 0 0175 35.59V51.7a3 3 0 01-3.09 3.09"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff744a",
  d: "M47.41 32.72H43a2.92 2.92 0 00-2.87 2.87V51.7A2.93 2.93 0 0043 54.57h26.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#414b59",
  d: "M40.12 40H75v-3.09H40.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcebf",
  d: "M54 45.3H43.66a.67.67 0 110-1.33H54a.7.7 0 01.66.67 1 1 0 01-.66.66m7.54 4.19H43.43a.66.66 0 010-1.32h18.11a.7.7 0 01.66.66.58.58 0 01-.66.66"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b0c5d1",
  d: "M18.93 23.67a5 5 0 00-1.76-.45c-.66 0-1.11.22-1.11.67 0 .66.67.66 1.33.88 1.1.22 2 .66 2 1.77 0 .88-.66 1.54-1.76 1.76v1.33h-.88v-1.11a4.15 4.15 0 01-1.75-.44l.22-.88a5.23 5.23 0 001.77.44c.66 0 1.32-.22 1.32-.88s-.66-.67-1.32-.89c-.89-.22-2-.44-2-1.76 0-.89.66-1.55 1.77-1.77v-.88h.88v.88c.66 0 1.1.22 1.54.22a9.78 9.78 0 01-.25 1.11zm23.4-11.48v10.37h9.27z"
}));